import { Button, styled, Typography } from '@mui/material';
import type { FC } from 'react';
import { SlackLogoIcon } from '../../../../../../components/logo-icons';
import { useSlackAuthRedirect } from '../../../../../../hooks/requests/use-slack';
import { runMutation } from '../../../../../../utils/vy-mutation';

export const SlackRegistration: FC = () => {
  const connectSlackMutation = useSlackAuthRedirect();

  const handleConnectClick = async () => {
    await runMutation(connectSlackMutation, undefined, {
      pending: 'Connecting...',
      success: 'Connected',
      error: 'Failed to connect',
    });
  };

  return (
    <FormContainer>
      <SlackLogoIcon height="60px" width="60px" />
      <Typography variant="h4">Connect to slack</Typography>
      <Typography variant="h6">Click here to authorize from slack</Typography>
      <Button onClick={handleConnectClick} variant="contained">
        Connect
      </Button>
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});
